<template>
  <div>
    <div 
      class="content_whatsapp"
      @click="sendEvent"
    >
      <!-- Desktop y Mobile -->
      <div v-if="WhatsappActivate == true">
        <a href="https://wa.link/pvsj1l" target="_blank" rel="noopener noreferrer" class="btn_whatsapp">
          <img alt="avatar havo - havoline motoclub" class="icon_what" src="../assets/icon/whatsapp.webp"/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "whatsAppButton",
  data(){
    return{
      WhatsappActivate: false,
      ip_address: 0
    }
  },
  methods:{
    // chatWhatsapp(){
    //   window.$zoho = window.$zoho || {};
    //   window.$zoho.salesiq = window.$zoho.salesiq || {
    //       widgetcode: "6e5e940fb1c08a2e3f251b46a5a0d67efc68c243392e428cf6c623691060e5556610d653add587d463f8ad4bedd185d1",
    //       values: {},
    //       ready: function() {}
    //   };
    //   var d = document;
    //   var s = d.createElement("script");
    //   s.type = "text/javascript";
    //   s.id = "zsiqscript";
    //   s.defer = true;
    //   s.src = "https://salesiq.zoho.com/widget";
    //   var t = d.getElementsByTagName("script")[0];
    //   t.parentNode.insertBefore(s, t);
    // },
    getIp(){
      axios
      .get("https://ipinfo.io/json")
      .then((res) => {
        if(res.status == 200){
          this.ip_address = res.data.ip;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },
    sendEvent(){
      axios
      .post("api/send-data-event", {
        event_name: "Click en el botón de WhatsApp",
        event_time: Math.floor(Date.now() / 1000),
        event_source_url: document.URL,
        action_source: "website",
        user_data: {
          client_ip_address: this.ip_address,
          client_user_agent: window.navigator.userAgent
        }
      })
      .then(() => {
        console.log("Evento de WhatsApp enviado correctamente.");
      })
      .catch((err) => {
        console.log("Error enviando el evento:", err);
      });
    }
  },
  mounted(){
    // this.chatWhatsapp();
    this.WhatsappActivate = true;
    this.getIp();
  }
}
</script>

<style scoped>
.content_whatsapp{
  position: fixed;
  bottom: 5px;
  right: 5px;
  z-index: 9999;
}
.icon_what{
  width: 200px;
}
@media (max-width: 580px) {
  .icon_what{
    width: 180px !important;
  }
}
</style>